module.exports = __webpack_public_path__ + "img/download.937be13f.svg";